import classNames from "classnames";
import { useTheme } from "../../../theme/useTheme";
import { T } from "@config/lang";
import { useSearchBoxTabs } from "@presentation/shared/components/search-box/useSearchBoxTabs";
import { Settings } from "@config/tenants/settings";
import { useExtraTab } from "@presentation/shared/context/extra-tab-context";

export default function SearchBoxTabs() {
  const { searchBox } = useTheme();
  const { tabs, isActive, setSearchType } = useSearchBoxTabs();
  const { slug, setTab } = useExtraTab();

  return (
    <div className={classNames(searchBox.tabsContainer)}>
      <div className={classNames(searchBox.tabs)}>
        {tabs.map(([key, searchType]) => (
          <div
            key={key}
            className={classNames([
              "cursor-pointer",
              searchBox.tab.any,
              !slug && isActive(key)
                ? searchBox.tab.active
                : searchBox.tab.inactive,
            ])}
            onClick={() => setSearchType(key)}
          >
            {T[`search_type_${searchType}`]}
          </div>
        ))}
        {Settings.extraTabs.map((tab) => (
          <div
            key={"extra-tab-" + tab.slug}
            className={classNames([
              "cursor-pointer",
              searchBox.tab.any,
              slug === tab.slug ? searchBox.tab.active : searchBox.tab.inactive,
            ])}
            onClick={() => setTab(tab.slug)}
          >
            {T[`extra_tab_${tab.slug}`]}
          </div>
        ))}
      </div>
    </div>
  );
}
